import _ from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import $image_url from 'js/utils/image_url';
import { watchAnalyticsImpression } from 'js/analytics/metrics/analyticsTracking';

export class PremiumIcon extends React.Component {
  static propTypes = {
    popoverBodyText: PropTypes.string,
    popoverLinkUrl: PropTypes.string,
    popoverContainer: PropTypes.string,
    disableHoverBehavior: PropTypes.bool,
    popoverButtonText: PropTypes.string,
    onTriggerClick: PropTypes.func,
    onPopoverLinkClick: PropTypes.func,
    popoverImpression: PropTypes.shape({
      source: PropTypes.string.isRequired,
      key: PropTypes.string.isRequired,
      extra: PropTypes.object,
    }),
  };

  componentWillUnmount() {
    this.stopPopoverImpression();
  }

  initHoverPopover = (el) => {
    if (this.props.disableHoverBehavior) return null;
    if (!el) {
      this.popover?.$el.off('.analytics-upgrade-door');
      this.stopPopoverImpression();
      if (this.popover) this.popover.remove();
      return;
    }

    const triggerEl = $(el).closest('.js-PremiumIconContainerHoverWrapper');
    triggerEl.on(
      'hidden.bs.popover.analytics-upgrade-door',
      this.stopPopoverImpression,
    );
    this.popover = new HoverPopover({
      el: triggerEl,
      content: JST['premium/templates/premium_icon']({
        bodyText: this.props.popoverBodyText,
        learnMoreLinkUrl: this.props.popoverLinkUrl,
        buttonText: this.props.popoverButtonText,
      }),
      before_show: function (show) {
        $(this.popover.$el.data('bs.popover').tip()).css('max-width', 'none');
        show();
      }.bind(this),
      placement: 'bottom',
      html: true,
      container: this.props.popoverContainer,
      hide_delay: 300,
      on_shown: this.onPopoverShown,
    });
    triggerEl.on('click.analytics-upgrade-door', (e) => {
      if (!e.isDefaultPrevented()) this.props.onTriggerClick?.();
    });
  };

  onPopoverShown = (popoverEl) => {
    if (!popoverEl) return;

    popoverEl.off('.analytics-upgrade-door');
    if (this.props.onPopoverLinkClick) {
      popoverEl.on(
        'click.analytics-upgrade-door',
        'a.Button',
        this.handlePopoverLinkClick,
      );
    }

    this.stopPopoverImpression();
    const link = popoverEl.find('a.Button').get(0);
    const { popoverImpression } = this.props;
    if (link && popoverImpression) {
      this.popoverImpressionWatcher = watchAnalyticsImpression(
        link,
        popoverImpression.source,
        popoverImpression.key,
        popoverImpression.extra,
      );
    }
  };

  handlePopoverLinkClick = () => {
    this.props.onPopoverLinkClick?.();
  };

  stopPopoverImpression = () => {
    this.popoverImpressionWatcher?.stop();
    this.popoverImpressionWatcher = null;
  };

  render() {
    const containerClasses = classNames(
      'PremiumIconContainer',
      this.props.className,
      {
        'PremiumIconContainer--enableHoverBehavior':
          !this.props.disableHoverBehavior,
      },
    );
    return (
      <div
        className={containerClasses}
        style={this.props.style || {}}
        ref={this.initHoverPopover}
      >
        <img
          className="PremiumIconContainer-gold"
          src={$image_url('flexible_premium_upgrade/premium_icon_gold.svg')}
          style={{ width: '12px' }}
        />
        <img
          className="PremiumIconContainer-gray"
          src={$image_url('flexible_premium_upgrade/premium_icon_gray.svg')}
          style={{ width: '12px' }}
        />
      </div>
    );
  }
}
